import _assertThisInitialized from "/home/zack/trax/frontend/node_modules/@babel/runtime/helpers/esm/assertThisInitialized";
import _toConsumableArray from "/home/zack/trax/frontend/node_modules/@babel/runtime/helpers/esm/toConsumableArray";
import _slicedToArray from "/home/zack/trax/frontend/node_modules/@babel/runtime/helpers/esm/slicedToArray";
import _regeneratorRuntime from "/home/zack/trax/frontend/node_modules/@babel/runtime/regenerator";
import _possibleConstructorReturn from "/home/zack/trax/frontend/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/home/zack/trax/frontend/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";
import _inherits from "/home/zack/trax/frontend/node_modules/@babel/runtime/helpers/esm/inherits";
import _wrapNativeSuper from "/home/zack/trax/frontend/node_modules/@babel/runtime/helpers/esm/wrapNativeSuper";
import _classCallCheck from "/home/zack/trax/frontend/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/home/zack/trax/frontend/node_modules/@babel/runtime/helpers/esm/createClass";
var __defProp = Object.defineProperty;
var __defProps = Object.defineProperties;
var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;

var __defNormalProp = function __defNormalProp(obj, key, value) {
  return key in obj ? __defProp(obj, key, {
    enumerable: true,
    configurable: true,
    writable: true,
    value: value
  }) : obj[key] = value;
};

var __spreadValues = function __spreadValues(a, b) {
  for (var prop in b || (b = {})) {
    if (__hasOwnProp.call(b, prop)) __defNormalProp(a, prop, b[prop]);
  }

  if (__getOwnPropSymbols) {
    var _iteratorNormalCompletion = true;
    var _didIteratorError = false;
    var _iteratorError = undefined;

    try {
      for (var _iterator = __getOwnPropSymbols(b)[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
        var prop = _step.value;
        if (__propIsEnum.call(b, prop)) __defNormalProp(a, prop, b[prop]);
      }
    } catch (err) {
      _didIteratorError = true;
      _iteratorError = err;
    } finally {
      try {
        if (!_iteratorNormalCompletion && _iterator.return != null) {
          _iterator.return();
        }
      } finally {
        if (_didIteratorError) {
          throw _iteratorError;
        }
      }
    }
  }

  return a;
};

var __spreadProps = function __spreadProps(a, b) {
  return __defProps(a, __getOwnPropDescs(b));
};

var __objRest = function __objRest(source, exclude) {
  var target = {};

  for (var prop in source) {
    if (__hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0) target[prop] = source[prop];
  }

  if (source != null && __getOwnPropSymbols) {
    var _iteratorNormalCompletion2 = true;
    var _didIteratorError2 = false;
    var _iteratorError2 = undefined;

    try {
      for (var _iterator2 = __getOwnPropSymbols(source)[Symbol.iterator](), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
        var prop = _step2.value;
        if (exclude.indexOf(prop) < 0 && __propIsEnum.call(source, prop)) target[prop] = source[prop];
      }
    } catch (err) {
      _didIteratorError2 = true;
      _iteratorError2 = err;
    } finally {
      try {
        if (!_iteratorNormalCompletion2 && _iterator2.return != null) {
          _iterator2.return();
        }
      } finally {
        if (_didIteratorError2) {
          throw _iteratorError2;
        }
      }
    }
  }

  return target;
};

var __accessCheck = function __accessCheck(obj, member, msg) {
  if (!member.has(obj)) throw TypeError("Cannot " + msg);
};

var __privateGet = function __privateGet(obj, member, getter) {
  __accessCheck(obj, member, "read from private field");

  return getter ? getter.call(obj) : member.get(obj);
};

var __privateAdd = function __privateAdd(obj, member, value) {
  if (member.has(obj)) throw TypeError("Cannot add the same private member more than once");
  member instanceof WeakSet ? member.add(obj) : member.set(obj, value);
};

var __privateSet = function __privateSet(obj, member, value, setter) {
  __accessCheck(obj, member, "write to private field");

  setter ? setter.call(obj, value) : member.set(obj, value);
  return value;
};

var __privateMethod = function __privateMethod(obj, member, method) {
  __accessCheck(obj, member, "access private method");

  return method;
};

var __async = function __async(__this, __arguments, generator) {
  return new Promise(function (resolve, reject) {
    var fulfilled = function fulfilled(value) {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    };

    var rejected = function rejected(value) {
      try {
        step(generator.throw(value));
      } catch (e) {
        reject(e);
      }
    };

    var step = function step(x) {
      return x.done ? resolve(x.value) : Promise.resolve(x.value).then(fulfilled, rejected);
    };

    step((generator = generator.apply(__this, __arguments)).next());
  });
}; // src/search/constants.ts


var SEARCH_URL = "https://api.mapbox.com/search/v1";
var ENDPOINT_SUGGEST = "suggest";
var ENDPOINT_RETRIEVE = "retrieve";
var ENDPOINT_FORWARD = "forward";
var ENDPOINT_REVERSE = "reverse";
var SUGGEST_URL = "".concat(SEARCH_URL, "/").concat(ENDPOINT_SUGGEST);
var RETRIEVE_URL = "".concat(SEARCH_URL, "/").concat(ENDPOINT_RETRIEVE);
var FORWARD_URL = "".concat(SEARCH_URL, "/").concat(ENDPOINT_FORWARD);
var PERMANENT_FORWARD_URL = "".concat(SEARCH_URL, "/permanent/").concat(ENDPOINT_FORWARD);
var REVERSE_URL = "".concat(SEARCH_URL, "/").concat(ENDPOINT_REVERSE);
var PERMANENT_REVERSE_URL = "".concat(SEARCH_URL, "/permanent/").concat(ENDPOINT_REVERSE); // src/LngLat.ts

var LngLat =
/*#__PURE__*/
function () {
  function LngLat(lng, lat) {
    _classCallCheck(this, LngLat);

    if (isNaN(lng) || isNaN(lat)) {
      throw new Error("Invalid LngLat object: (".concat(lng, ", ").concat(lat, ")"));
    }

    this.lng = +lng;
    this.lat = +lat;

    if (this.lat > 90 || this.lat < -90) {
      throw new Error("Invalid LngLat latitude value: must be between -90 and 90");
    }

    if (this.lng > 180 || this.lng < -180) {
      throw new Error("Invalid LngLat longitude value: must be between -180 and 180");
    }
  }

  _createClass(LngLat, [{
    key: "toArray",
    value: function toArray() {
      return [this.lng, this.lat];
    }
  }, {
    key: "toString",
    value: function toString() {
      return "LngLat(".concat(this.lng, ", ").concat(this.lat, ")");
    }
  }], [{
    key: "convert",
    value: function convert(input) {
      if (input instanceof LngLat) {
        return new LngLat(input.lng, input.lat);
      }

      if (Array.isArray(input) && input.length === 2) {
        return new LngLat(Number(input[0]), Number(input[1]));
      }

      if (!Array.isArray(input) && typeof input == "object" && input !== null && ("lng" in input || "lon" in input) && "lat" in input) {
        return new LngLat(Number("lng" in input ? input.lng : input.lon), Number(input.lat));
      }

      throw new Error("`LngLatLike` argument must be specified as an object {lng: <lng>, lat: <lat>}, an object {lon: <lng>, lat: <lat>}, or an array of [<lng>, <lat>]");
    }
  }]);

  return LngLat;
}(); // src/LngLatBounds.ts


var LngLatBounds =
/*#__PURE__*/
function () {
  function LngLatBounds(sw, ne) {
    _classCallCheck(this, LngLatBounds);

    this._sw = LngLat.convert(sw);
    this._ne = LngLat.convert(ne);
  }

  _createClass(LngLatBounds, [{
    key: "getSouthWest",
    value: function getSouthWest() {
      return this._sw;
    }
  }, {
    key: "getNorthEast",
    value: function getNorthEast() {
      return this._ne;
    }
  }, {
    key: "getNorthWest",
    value: function getNorthWest() {
      return new LngLat(this.getWest(), this.getNorth());
    }
  }, {
    key: "getSouthEast",
    value: function getSouthEast() {
      return new LngLat(this.getEast(), this.getSouth());
    }
  }, {
    key: "getWest",
    value: function getWest() {
      return this._sw.lng;
    }
  }, {
    key: "getSouth",
    value: function getSouth() {
      return this._sw.lat;
    }
  }, {
    key: "getEast",
    value: function getEast() {
      return this._ne.lng;
    }
  }, {
    key: "getNorth",
    value: function getNorth() {
      return this._ne.lat;
    }
  }, {
    key: "toArray",
    value: function toArray() {
      return [this._sw.toArray(), this._ne.toArray()];
    }
  }, {
    key: "toFlatArray",
    value: function toFlatArray() {
      return [this._sw.lng, this._sw.lat, this._ne.lng, this._ne.lat];
    }
  }, {
    key: "toString",
    value: function toString() {
      return "LngLatBounds(".concat(this._sw.toString(), ", ").concat(this._ne.toString(), ")");
    }
  }], [{
    key: "convert",
    value: function convert(input) {
      if (!input) {
        throw new Error("Invalid LngLatBounds convert value: falsy");
      }

      if (input instanceof LngLatBounds) {
        return new LngLatBounds(input.getSouthWest(), input.getNorthEast());
      }

      if (Array.isArray(input) && input.length === 2) {
        return new LngLatBounds(LngLat.convert(input[0]), LngLat.convert(input[1]));
      }

      if (Array.isArray(input) && input.length === 4) {
        return new LngLatBounds(LngLat.convert([input[0], input[1]]), LngLat.convert([input[2], input[3]]));
      }

      throw new Error("`LngLatBoundsLike` argument must be specified as an array [<LngLatLike>, <LngLatLike>] or an array [<west>, <south>, <east>, <north>]");
    }
  }]);

  return LngLatBounds;
}(); // src/utils/uuid.ts


function generateUUID() {
  var randomString = Math.random().toString(16) + Date.now().toString(16) + Math.random().toString(16);
  var uuidString = randomString.replace(/\./g, "");
  var uuid = [uuidString.slice(0, 8), uuidString.slice(8, 12), "4" + uuidString.slice(12, 15) + "-8" + uuidString.slice(15, 18), uuidString.slice(18, 30)].join("-");
  return uuid;
} // src/SessionToken.ts


var SessionToken =
/*#__PURE__*/
function () {
  function SessionToken(id) {
    _classCallCheck(this, SessionToken);

    this.id = id != null ? id : generateUUID();
  }

  _createClass(SessionToken, [{
    key: "toString",
    value: function toString() {
      return this.id;
    }
  }], [{
    key: "convert",
    value: function convert(token) {
      return new SessionToken(token instanceof SessionToken ? token.id : token.toString());
    }
  }]);

  return SessionToken;
}(); // src/MapboxError.ts


var UNKNOWN_ERROR = "Unknown error";

var MapboxError =
/*#__PURE__*/
function (_Error) {
  _inherits(MapboxError, _Error);

  function MapboxError(json, statusCode) {
    var _this;

    _classCallCheck(this, MapboxError);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(MapboxError).call(this, String(json.message || json.error || UNKNOWN_ERROR)));
    _this.name = "MapboxError";
    _this.statusCode = statusCode;
    return _this;
  }

  _createClass(MapboxError, [{
    key: "toString",
    value: function toString() {
      return "".concat(this.name, " (").concat(this.statusCode, "): ").concat(this.message);
    }
  }]);

  return MapboxError;
}(_wrapNativeSuper(Error));

function handleNonOkRes(res) {
  return __async(this, null,
  /*#__PURE__*/
  _regeneratorRuntime.mark(function _callee() {
    var json;
    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            if (res.ok) {
              _context.next = 5;
              break;
            }

            _context.next = 3;
            return res.json();

          case 3:
            json = _context.sent;
            throw new MapboxError(json, res.status);

          case 5:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }));
} // src/fetch.ts


var _fetchImpl = globalThis.fetch;
var _abortControllerImpl = globalThis.AbortController;

function polyfillFetch(_ref) {
  var fetch = _ref.fetch,
      AbortController = _ref.AbortController;
  var force = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;

  if (!fetch) {
    throw new Error("Fetch implementation must include implementations of `fetch`.");
  }

  if (_fetchImpl && !force) {
    return;
  }

  _fetchImpl = fetch;
  _abortControllerImpl = AbortController;
}

function getFetch() {
  if (!_fetchImpl) {
    throw new Error("Fetch implementation not found. Please include a fetch polyfill in your application or use `polyfillFetch` from `@mapbox/search-js-core` to fix this issue.");
  }

  return {
    fetch: _fetchImpl,
    AbortController: _abortControllerImpl
  };
} // src/utils/queryParams.ts


function queryParams() {
  var params = [];

  for (var _len = arguments.length, objects = new Array(_len), _key = 0; _key < _len; _key++) {
    objects[_key] = arguments[_key];
  }

  for (var _i = 0, _objects = objects; _i < _objects.length; _i++) {
    var obj = _objects[_i];
    if (!obj) continue;
    var entries = Object.entries(obj);

    for (var _i2 = 0, _entries = entries; _i2 < _entries.length; _i2++) {
      var _ref4 = _entries[_i2];

      var _ref3 = _slicedToArray(_ref4, 2);

      var key = _ref3[0];
      var value = _ref3[1];
      if (value == null) continue;
      params.push("".concat(key, "=").concat(encodeURIComponent(String(value))));
    }
  }

  return params.join("&");
} // src/search/MapboxSearch.ts


var _getQueryParams, getQueryParams_fn, _getFetchInfo, getFetchInfo_fn;

var _MapboxSearch =
/*#__PURE__*/
function () {
  function _MapboxSearch() {
    var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

    _classCallCheck(this, _MapboxSearch);

    __privateAdd(this, _getQueryParams);

    __privateAdd(this, _getFetchInfo);

    var _a = options,
        accessToken = _a.accessToken,
        defaults = __objRest(_a, ["accessToken"]);

    this.accessToken = accessToken;
    this.defaults = __spreadValues(__spreadValues({}, _MapboxSearch.defaults), defaults);
  }

  _createClass(_MapboxSearch, [{
    key: "suggest",
    value: function suggest(searchText, optionsArg) {
      return __async(this, null,
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee2() {
        var sessionToken, signal, options, url, _getFetch, fetch, res, json;

        return _regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                if (searchText) {
                  _context2.next = 2;
                  break;
                }

                throw new Error("searchText is required");

              case 2:
                sessionToken = optionsArg.sessionToken, signal = optionsArg.signal;
                options = __spreadProps(__spreadValues(__spreadValues({}, this.defaults), optionsArg), {
                  sessionToken: sessionToken
                });

                if (!(options.eta_type && (!options.origin || !options.navigation_profile))) {
                  _context2.next = 6;
                  break;
                }

                throw new Error("to provide eta estimate: eta, navigation_profile, and origin are required");

              case 6:
                if (!(options.origin && !options.navigation_profile)) {
                  _context2.next = 8;
                  break;
                }

                throw new Error("to provide distance estimate: both navigation_profile and origin are required");

              case 8:
                url = new URL("".concat(SUGGEST_URL, "/").concat(encodeURIComponent(searchText)));
                url.search = __privateMethod(this, _getQueryParams, getQueryParams_fn).call(this, options);
                _getFetch = getFetch(), fetch = _getFetch.fetch;
                _context2.next = 13;
                return fetch(url.toString(), {
                  signal: signal
                });

              case 13:
                res = _context2.sent;
                _context2.next = 16;
                return handleNonOkRes(res);

              case 16:
                _context2.next = 18;
                return res.json();

              case 18:
                json = _context2.sent;
                return _context2.abrupt("return", json);

              case 20:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, this);
      }));
    }
  }, {
    key: "retrieve",
    value: function retrieve(suggestion, optionsArg) {
      return __async(this, null,
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee3() {
        var sessionTokenLike, signal, sessionToken, url, _getFetch2, fetch, res, json;

        return _regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                if (suggestion) {
                  _context3.next = 2;
                  break;
                }

                throw new Error("suggestion is required");

              case 2:
                if (this.canRetrieve(suggestion)) {
                  _context3.next = 4;
                  break;
                }

                throw new Error("suggestion cannot be retrieved");

              case 4:
                sessionTokenLike = optionsArg.sessionToken, signal = optionsArg.signal;
                sessionToken = SessionToken.convert(sessionTokenLike);
                url = new URL(RETRIEVE_URL);
                url.search = queryParams({
                  access_token: this.accessToken,
                  session_token: sessionToken.id
                });
                _getFetch2 = getFetch(), fetch = _getFetch2.fetch;
                _context3.next = 11;
                return fetch(url.toString(), __spreadProps(__spreadValues({}, __privateMethod(this, _getFetchInfo, getFetchInfo_fn).call(this, suggestion)), {
                  signal: signal
                }));

              case 11:
                res = _context3.sent;
                _context3.next = 14;
                return handleNonOkRes(res);

              case 14:
                _context3.next = 16;
                return res.json();

              case 16:
                json = _context3.sent;
                return _context3.abrupt("return", json);

              case 18:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3, this);
      }));
    }
  }, {
    key: "canRetrieve",
    value: function canRetrieve(suggestion) {
      var action = suggestion.action;

      if (!action) {
        return false;
      }

      return action.method === "POST" && action.endpoint === ENDPOINT_RETRIEVE;
    }
  }, {
    key: "canSuggest",
    value: function canSuggest(suggestion) {
      var action = suggestion.action;

      if (!action) {
        return false;
      }

      return action.method === "POST" && action.endpoint === ENDPOINT_SUGGEST;
    }
  }, {
    key: "forward",
    value: function forward(_0) {
      return __async(this, arguments,
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee4(searchText) {
        var optionsArg,
            options,
            baseUrl,
            url,
            _getFetch3,
            fetch,
            res,
            json,
            _args4 = arguments;

        return _regeneratorRuntime.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                optionsArg = _args4.length > 1 && _args4[1] !== undefined ? _args4[1] : {};

                if (searchText) {
                  _context4.next = 3;
                  break;
                }

                throw new Error("searchText is required");

              case 3:
                options = __spreadValues(__spreadValues({}, this.defaults), optionsArg);
                baseUrl = options.permanent ? PERMANENT_FORWARD_URL : FORWARD_URL;
                url = new URL("".concat(baseUrl, "/").concat(encodeURIComponent(searchText)));
                url.search = __privateMethod(this, _getQueryParams, getQueryParams_fn).call(this, options);
                _getFetch3 = getFetch(), fetch = _getFetch3.fetch;
                _context4.next = 10;
                return fetch(url.toString(), {
                  signal: options.signal
                });

              case 10:
                res = _context4.sent;
                _context4.next = 13;
                return handleNonOkRes(res);

              case 13:
                _context4.next = 15;
                return res.json();

              case 15:
                json = _context4.sent;
                return _context4.abrupt("return", json);

              case 17:
              case "end":
                return _context4.stop();
            }
          }
        }, _callee4, this);
      }));
    }
  }, {
    key: "reverse",
    value: function reverse(_0) {
      return __async(this, arguments,
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee5(lngLat) {
        var optionsArg,
            options,
            searchText,
            baseUrl,
            url,
            _getFetch4,
            fetch,
            res,
            json,
            _args5 = arguments;

        return _regeneratorRuntime.wrap(function _callee5$(_context5) {
          while (1) {
            switch (_context5.prev = _context5.next) {
              case 0:
                optionsArg = _args5.length > 1 && _args5[1] !== undefined ? _args5[1] : {};

                if (lngLat) {
                  _context5.next = 3;
                  break;
                }

                throw new Error("lngLat is required");

              case 3:
                options = __spreadValues(__spreadValues({}, this.defaults), optionsArg);
                searchText = typeof lngLat === "string" ? lngLat : LngLat.convert(lngLat).toArray().join(",");
                baseUrl = options.permanent ? PERMANENT_REVERSE_URL : REVERSE_URL;
                url = new URL("".concat(baseUrl, "/").concat(encodeURIComponent(searchText)));
                url.search = queryParams({
                  access_token: this.accessToken,
                  language: options.language,
                  limit: options.limit
                }, options.types && {
                  types: typeof options.types === "string" ? options.types : _toConsumableArray(options.types).join(",")
                });
                _getFetch4 = getFetch(), fetch = _getFetch4.fetch;
                _context5.next = 11;
                return fetch(url.toString(), {
                  signal: options.signal
                });

              case 11:
                res = _context5.sent;
                _context5.next = 14;
                return handleNonOkRes(res);

              case 14:
                _context5.next = 16;
                return res.json();

              case 16:
                json = _context5.sent;
                return _context5.abrupt("return", json);

              case 18:
              case "end":
                return _context5.stop();
            }
          }
        }, _callee5, this);
      }));
    }
  }]);

  return _MapboxSearch;
}();

var MapboxSearch = _MapboxSearch;
_getQueryParams = new WeakSet();

getQueryParams_fn = function getQueryParams_fn(options) {
  return queryParams({
    access_token: this.accessToken,
    language: options.language,
    country: options.country,
    limit: options.limit,
    navigation_profile: options.navigation_profile,
    eta_type: options.eta_type
  }, options.sessionToken && {
    session_token: SessionToken.convert(options.sessionToken).id
  }, options.origin && {
    origin: typeof options.origin === "string" ? options.origin : LngLat.convert(options.origin).toArray().join(",")
  }, options.proximity && {
    proximity: typeof options.proximity === "string" ? options.proximity : LngLat.convert(options.proximity).toArray().join(",")
  }, options.bbox && {
    bbox: typeof options.bbox === "string" ? options.bbox : LngLatBounds.convert(options.bbox).toFlatArray().join(",")
  }, options.types && {
    types: typeof options.types === "string" ? options.types : _toConsumableArray(options.types).join(",")
  });
};

_getFetchInfo = new WeakSet();

getFetchInfo_fn = function getFetchInfo_fn(suggestion) {
  if (!this.canRetrieve(suggestion) && !this.canSuggest(suggestion)) {
    throw new Error("Suggestion cannot be retrieved or suggested");
  }

  var action = suggestion.action;
  var body = JSON.stringify(action.body);
  return {
    method: action.method,
    body: body,
    headers: {
      "Content-Type": "application/json",
      "Content-Length": body.length.toString()
    }
  };
};

MapboxSearch.defaults = {
  language: "en"
}; // src/autofill/constants.ts

var SEARCH_URL2 = "https://api.mapbox.com/autofill/v1";
var ENDPOINT_SUGGEST2 = "suggest";
var ENDPOINT_RETRIEVE2 = "retrieve";
var SUGGEST_URL2 = "".concat(SEARCH_URL2, "/").concat(ENDPOINT_SUGGEST2);
var RETRIEVE_URL2 = "".concat(SEARCH_URL2, "/").concat(ENDPOINT_RETRIEVE2); // src/autofill/MapboxAutofill.ts

var _getQueryParams2, getQueryParams_fn2;

var _MapboxAutofill =
/*#__PURE__*/
function () {
  function _MapboxAutofill() {
    var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

    _classCallCheck(this, _MapboxAutofill);

    __privateAdd(this, _getQueryParams2);

    var _a = options,
        accessToken = _a.accessToken,
        defaults = __objRest(_a, ["accessToken"]);

    this.accessToken = accessToken;
    this.defaults = __spreadValues(__spreadValues({}, _MapboxAutofill.defaults), defaults);
  }

  _createClass(_MapboxAutofill, [{
    key: "suggest",
    value: function suggest(searchText, optionsArg) {
      return __async(this, null,
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee6() {
        var sessionToken, signal, options, url, _getFetch5, fetch, res, json;

        return _regeneratorRuntime.wrap(function _callee6$(_context6) {
          while (1) {
            switch (_context6.prev = _context6.next) {
              case 0:
                if (searchText) {
                  _context6.next = 2;
                  break;
                }

                throw new Error("searchText is required");

              case 2:
                sessionToken = optionsArg.sessionToken, signal = optionsArg.signal;
                options = __spreadProps(__spreadValues(__spreadValues({}, this.defaults), optionsArg), {
                  sessionToken: sessionToken
                });
                url = new URL("".concat(SUGGEST_URL2, "/").concat(encodeURIComponent(searchText)));
                url.search = __privateMethod(this, _getQueryParams2, getQueryParams_fn2).call(this, options);
                _getFetch5 = getFetch(), fetch = _getFetch5.fetch;
                _context6.next = 9;
                return fetch(url.toString(), {
                  signal: signal
                });

              case 9:
                res = _context6.sent;
                _context6.next = 12;
                return handleNonOkRes(res);

              case 12:
                _context6.next = 14;
                return res.json();

              case 14:
                json = _context6.sent;
                return _context6.abrupt("return", __spreadProps(__spreadValues({}, json), {
                  suggestions: json.suggestions.map(function (suggestion) {
                    return __spreadProps(__spreadValues({}, suggestion), {
                      original_search_text: searchText
                    });
                  })
                }));

              case 16:
              case "end":
                return _context6.stop();
            }
          }
        }, _callee6, this);
      }));
    }
  }, {
    key: "retrieve",
    value: function retrieve(suggestion, optionsArg) {
      return __async(this, null,
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee7() {
        var sessionTokenLike, signal, sessionToken, url, _getFetch6, fetch, res, json;

        return _regeneratorRuntime.wrap(function _callee7$(_context7) {
          while (1) {
            switch (_context7.prev = _context7.next) {
              case 0:
                if (suggestion) {
                  _context7.next = 2;
                  break;
                }

                throw new Error("suggestion is required");

              case 2:
                if (this.canRetrieve(suggestion)) {
                  _context7.next = 4;
                  break;
                }

                throw new Error("suggestion cannot be retrieved");

              case 4:
                sessionTokenLike = optionsArg.sessionToken, signal = optionsArg.signal;
                sessionToken = SessionToken.convert(sessionTokenLike);
                url = new URL("".concat(RETRIEVE_URL2, "/").concat(suggestion.action.id));
                url.search = queryParams({
                  access_token: this.accessToken,
                  session_token: sessionToken.id
                });
                _getFetch6 = getFetch(), fetch = _getFetch6.fetch;
                _context7.next = 11;
                return fetch(url.toString(), {
                  signal: signal
                });

              case 11:
                res = _context7.sent;
                _context7.next = 14;
                return handleNonOkRes(res);

              case 14:
                _context7.next = 16;
                return res.json();

              case 16:
                json = _context7.sent;
                return _context7.abrupt("return", json);

              case 18:
              case "end":
                return _context7.stop();
            }
          }
        }, _callee7, this);
      }));
    }
  }, {
    key: "canRetrieve",
    value: function canRetrieve(suggestion) {
      var action = suggestion.action;
      return typeof (action == null ? void 0 : action.id) === "string";
    }
  }]);

  return _MapboxAutofill;
}();

var MapboxAutofill = _MapboxAutofill;
_getQueryParams2 = new WeakSet();

getQueryParams_fn2 = function getQueryParams_fn2(options) {
  return queryParams({
    types: "address",
    streets: true,
    access_token: this.accessToken,
    language: options.language,
    country: options.country,
    limit: options.limit
  }, options.sessionToken && {
    session_token: SessionToken.convert(options.sessionToken).id
  }, options.proximity && {
    proximity: typeof options.proximity === "string" ? options.proximity : LngLat.convert(options.proximity).toArray().join(",")
  }, options.bbox && {
    bbox: typeof options.bbox === "string" ? options.bbox : LngLatBounds.convert(options.bbox).toFlatArray().join(",")
  });
};

MapboxAutofill.defaults = {
  language: "en",
  proximity: "ip"
}; // src/validate/constants.ts

var SEARCH_URL3 = "https://api.mapbox.com/autofill/v1";
var ENDPOINT_VALIDATE = "retrieve";
var VALIDATE_URL = "".concat(SEARCH_URL3, "/").concat(ENDPOINT_VALIDATE); // src/validate/MapboxValidate.ts

var _getQueryParams3, getQueryParams_fn3;

var _MapboxValidate =
/*#__PURE__*/
function () {
  function _MapboxValidate() {
    var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

    _classCallCheck(this, _MapboxValidate);

    __privateAdd(this, _getQueryParams3);

    var _a = options,
        accessToken = _a.accessToken,
        defaults = __objRest(_a, ["accessToken"]);

    this.accessToken = accessToken;
    this.defaults = __spreadValues(__spreadValues({}, _MapboxValidate.defaults), defaults);
  }

  _createClass(_MapboxValidate, [{
    key: "validate",
    value: function validate(searchText, optionsArg) {
      return __async(this, null,
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee8() {
        var sessionToken, signal, options, url, _getFetch7, fetch, res, json;

        return _regeneratorRuntime.wrap(function _callee8$(_context8) {
          while (1) {
            switch (_context8.prev = _context8.next) {
              case 0:
                if (searchText) {
                  _context8.next = 2;
                  break;
                }

                throw new Error("searchText is required");

              case 2:
                sessionToken = optionsArg.sessionToken, signal = optionsArg.signal;
                options = __spreadProps(__spreadValues(__spreadValues({}, this.defaults), optionsArg), {
                  sessionToken: sessionToken
                });
                url = new URL("".concat(VALIDATE_URL, "/").concat(encodeURIComponent(searchText)));
                url.search = __privateMethod(this, _getQueryParams3, getQueryParams_fn3).call(this, options);
                _getFetch7 = getFetch(), fetch = _getFetch7.fetch;
                _context8.next = 9;
                return fetch(url.toString(), {
                  signal: signal
                });

              case 9:
                res = _context8.sent;
                _context8.next = 12;
                return handleNonOkRes(res);

              case 12:
                _context8.next = 14;
                return res.json();

              case 14:
                json = _context8.sent;

                if (json.features.length > 0) {
                  json.features = [json.features[0]];
                }

                return _context8.abrupt("return", json);

              case 17:
              case "end":
                return _context8.stop();
            }
          }
        }, _callee8, this);
      }));
    }
  }]);

  return _MapboxValidate;
}();

var MapboxValidate = _MapboxValidate;
_getQueryParams3 = new WeakSet();

getQueryParams_fn3 = function getQueryParams_fn3(options) {
  return queryParams({
    access_token: this.accessToken,
    language: options.language,
    country: options.country
  }, options.sessionToken && {
    session_token: SessionToken.convert(options.sessionToken).id
  }, options.proximity && {
    proximity: typeof options.proximity === "string" ? options.proximity : LngLat.convert(options.proximity).toArray().join(",")
  }, options.bbox && {
    bbox: typeof options.bbox === "string" ? options.bbox : LngLatBounds.convert(options.bbox).toFlatArray().join(",")
  });
};

MapboxValidate.defaults = {
  language: "en",
  proximity: "ip"
}; // src/geocode/constants.ts

var SEARCH_URL4 = "https://api.mapbox.com/geocoding/v5";
var TEMP_URL = "".concat(SEARCH_URL4, "/mapbox.places");
var PERMANENT_URL = "".concat(SEARCH_URL4, "/mapbox.places-permanent"); // src/geocode/MapboxGeocode.ts

var _getQueryParams4, getQueryParams_fn4;

var MapboxGeocode =
/*#__PURE__*/
function () {
  function MapboxGeocode() {
    var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

    _classCallCheck(this, MapboxGeocode);

    __privateAdd(this, _getQueryParams4);

    var _a = options,
        accessToken = _a.accessToken,
        defaults = __objRest(_a, ["accessToken"]);

    this.accessToken = accessToken;
    this.defaults = __spreadValues({}, defaults);
  }

  _createClass(MapboxGeocode, [{
    key: "forward",
    value: function forward(searchText, optionsArg) {
      return __async(this, null,
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee9() {
        var signal, options, baseUrl, url, _getFetch8, fetch, fetchInit, res, json;

        return _regeneratorRuntime.wrap(function _callee9$(_context9) {
          while (1) {
            switch (_context9.prev = _context9.next) {
              case 0:
                if (searchText) {
                  _context9.next = 2;
                  break;
                }

                throw new Error("searchText is required");

              case 2:
                if (optionsArg) {
                  signal = optionsArg.signal;
                }

                options = __spreadValues(__spreadValues({}, this.defaults), optionsArg);
                baseUrl = options.permanent ? PERMANENT_URL : TEMP_URL;
                url = new URL("".concat(baseUrl, "/").concat(encodeURIComponent(searchText), ".json"));
                url.search = __privateMethod(this, _getQueryParams4, getQueryParams_fn4).call(this, options);
                _getFetch8 = getFetch(), fetch = _getFetch8.fetch;
                fetchInit = signal ? {
                  signal: signal
                } : {};
                _context9.next = 11;
                return fetch(url.toString(), fetchInit);

              case 11:
                res = _context9.sent;
                _context9.next = 14;
                return handleNonOkRes(res);

              case 14:
                _context9.next = 16;
                return res.json();

              case 16:
                json = _context9.sent;
                return _context9.abrupt("return", json);

              case 18:
              case "end":
                return _context9.stop();
            }
          }
        }, _callee9, this);
      }));
    }
  }, {
    key: "reverse",
    value: function reverse(lngLat, optionsArg) {
      return __async(this, null,
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee10() {
        var signal, options, searchText, baseUrl, url, _getFetch9, fetch, fetchInit, res, json;

        return _regeneratorRuntime.wrap(function _callee10$(_context10) {
          while (1) {
            switch (_context10.prev = _context10.next) {
              case 0:
                if (lngLat) {
                  _context10.next = 2;
                  break;
                }

                throw new Error("lngLat is required");

              case 2:
                if (optionsArg) {
                  signal = optionsArg.signal;
                }

                options = __spreadValues(__spreadValues({}, this.defaults), optionsArg);
                searchText = typeof lngLat === "string" ? lngLat : LngLat.convert(lngLat).toArray().join(",");
                baseUrl = options.permanent ? PERMANENT_URL : TEMP_URL;
                url = new URL("".concat(baseUrl, "/").concat(encodeURIComponent(searchText), ".json"));
                url.search = __privateMethod(this, _getQueryParams4, getQueryParams_fn4).call(this, options, true);
                _getFetch9 = getFetch(), fetch = _getFetch9.fetch;
                fetchInit = signal ? {
                  signal: signal
                } : {};
                _context10.next = 12;
                return fetch(url.toString(), fetchInit);

              case 12:
                res = _context10.sent;
                _context10.next = 15;
                return handleNonOkRes(res);

              case 15:
                _context10.next = 17;
                return res.json();

              case 17:
                json = _context10.sent;
                return _context10.abrupt("return", json);

              case 19:
              case "end":
                return _context10.stop();
            }
          }
        }, _callee10, this);
      }));
    }
  }]);

  return MapboxGeocode;
}();

_getQueryParams4 = new WeakSet();

getQueryParams_fn4 = function getQueryParams_fn4(options) {
  var isReverse = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;

  if (isReverse) {
    ["proximity", "autocomplete", "fuzzyMatch", "bbox"].forEach(function (key) {
      if (key in options) {
        delete options[key];
      }
    });
  }

  return queryParams({
    access_token: this.accessToken,
    language: options.language,
    country: options.country,
    limit: options.limit,
    autocomplete: options.autocomplete,
    fuzzyMatch: options.fuzzyMatch,
    routing: options.routing,
    worldview: options.worldview
  }, options.proximity && {
    proximity: typeof options.proximity === "string" ? options.proximity : LngLat.convert(options.proximity).toArray().join(",")
  }, options.bbox && {
    bbox: typeof options.bbox === "string" ? options.bbox : LngLatBounds.convert(options.bbox).toFlatArray().join(",")
  }, options.types && {
    types: typeof options.types === "string" ? options.types : _toConsumableArray(options.types).join(",")
  });
}; // src/types.ts


var MatchCodeConfidence =
/* @__PURE__ */
function (MatchCodeConfidence2) {
  MatchCodeConfidence2["exact"] = "exact";
  MatchCodeConfidence2["high"] = "high";
  MatchCodeConfidence2["medium"] = "medium";
  MatchCodeConfidence2["low"] = "low";
  return MatchCodeConfidence2;
}(MatchCodeConfidence || {}); // src/utils/Evented.ts


var _listeners;

var Evented =
/*#__PURE__*/
function () {
  function Evented() {
    _classCallCheck(this, Evented);

    __privateAdd(this, _listeners, {});
  }

  _createClass(Evented, [{
    key: "addEventListener",
    value: function addEventListener(type, listener) {
      var listenersArr = __privateGet(this, _listeners);

      if (!listenersArr[type]) {
        listenersArr[type] = [];
      }

      listenersArr[type].push(listener);
    }
  }, {
    key: "removeEventListener",
    value: function removeEventListener(type, listener) {
      var listenersArr = __privateGet(this, _listeners);

      if (!listenersArr[type]) {
        return;
      }

      var listeners = listenersArr[type];
      var index = listeners.indexOf(listener);

      if (index !== -1) {
        listeners.splice(index, 1);
      }
    }
  }, {
    key: "fire",
    value: function fire(type, arg0) {
      var listenersArr = __privateGet(this, _listeners);

      if (!listenersArr[type]) {
        return;
      }

      var listeners = listenersArr[type];
      var _iteratorNormalCompletion3 = true;
      var _didIteratorError3 = false;
      var _iteratorError3 = undefined;

      try {
        for (var _iterator3 = listeners[Symbol.iterator](), _step3; !(_iteratorNormalCompletion3 = (_step3 = _iterator3.next()).done); _iteratorNormalCompletion3 = true) {
          var listener = _step3.value;
          listener(arg0);
        }
      } catch (err) {
        _didIteratorError3 = true;
        _iteratorError3 = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion3 && _iterator3.return != null) {
            _iterator3.return();
          }
        } finally {
          if (_didIteratorError3) {
            throw _iteratorError3;
          }
        }
      }
    }
  }]);

  return Evented;
}();

_listeners = new WeakMap(); // src/utils/debounce.ts

function debounce(func, wait, signalFn) {
  var timeout = null;
  return function () {
    for (var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
      args[_key2] = arguments[_key2];
    }

    if (timeout !== null) {
      clearTimeout(timeout);
    }

    var signal = signalFn && signalFn();
    timeout = setTimeout(function () {
      timeout = null;

      if (signal == null ? void 0 : signal.aborted) {
        return;
      }

      func.apply(void 0, args);
    }, wait);
  };
} // src/SearchSession.ts


function createAbortController() {
  var _getFetch10 = getFetch(),
      AbortController = _getFetch10.AbortController;

  return new AbortController();
}

var _suggestions, _abort, _suggestDebounce;

var SearchSession =
/*#__PURE__*/
function (_Evented) {
  _inherits(SearchSession, _Evented);

  function SearchSession(search) {
    var _this2;

    var wait = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;

    _classCallCheck(this, SearchSession);

    _this2 = _possibleConstructorReturn(this, _getPrototypeOf(SearchSession).call(this));
    _this2.sessionToken = new SessionToken();

    __privateAdd(_assertThisInitialized(_this2), _suggestions, void 0);

    __privateAdd(_assertThisInitialized(_this2), _abort, createAbortController());

    __privateAdd(_assertThisInitialized(_this2), _suggestDebounce, void 0);

    __privateSet(_assertThisInitialized(_this2), _suggestDebounce, debounce(function (_0) {
      for (var _len3 = arguments.length, _1 = new Array(_len3 > 1 ? _len3 - 1 : 0), _key3 = 1; _key3 < _len3; _key3++) {
        _1[_key3 - 1] = arguments[_key3];
      }

      return __async(_assertThisInitialized(_this2), [_0].concat(_1),
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee11(searchText) {
        var options,
            res,
            _args11 = arguments;
        return _regeneratorRuntime.wrap(function _callee11$(_context11) {
          while (1) {
            switch (_context11.prev = _context11.next) {
              case 0:
                options = _args11.length > 1 && _args11[1] !== undefined ? _args11[1] : {};

                __privateGet(this, _abort).abort();

                __privateSet(this, _abort, createAbortController());

                if (searchText) {
                  _context11.next = 7;
                  break;
                }

                __privateSet(this, _suggestions, null);

                this.fire("suggest", __privateGet(this, _suggestions));
                return _context11.abrupt("return");

              case 7:
                _context11.prev = 7;
                _context11.next = 10;
                return this.search.suggest(searchText, __spreadProps(__spreadValues({
                  sessionToken: this.sessionToken
                }, options), {
                  signal: __privateGet(this, _abort).signal
                }));

              case 10:
                res = _context11.sent;

                __privateSet(this, _suggestions, res);

                this.fire("suggest", res);
                _context11.next = 20;
                break;

              case 15:
                _context11.prev = 15;
                _context11.t0 = _context11["catch"](7);

                if (!(_context11.t0.name === "AbortError")) {
                  _context11.next = 19;
                  break;
                }

                return _context11.abrupt("return");

              case 19:
                this.fire("suggesterror", _context11.t0);

              case 20:
              case "end":
                return _context11.stop();
            }
          }
        }, _callee11, this, [[7, 15]]);
      }));
    }, wait, function () {
      return __privateGet(_assertThisInitialized(_this2), _abort).signal;
    }));

    Object.defineProperties(_assertThisInitialized(_this2), {
      search: {
        value: search,
        writable: false
      },
      debounce: {
        value: wait,
        writable: false
      }
    });
    return _this2;
  }

  _createClass(SearchSession, [{
    key: "suggest",
    value: function suggest(searchText, options) {
      var _this3 = this;

      __privateGet(this, _suggestDebounce).call(this, searchText, options);

      return new Promise(function (resolve, reject) {
        var _suggestFn;

        var _suggestErrorFn;

        _suggestFn = function suggestFn(res) {
          _this3.removeEventListener("suggest", _suggestFn);

          _this3.removeEventListener("suggesterror", _suggestErrorFn);

          resolve(res);
        };

        _suggestErrorFn = function suggestErrorFn(err) {
          _this3.removeEventListener("suggest", _suggestFn);

          _this3.removeEventListener("suggesterror", _suggestErrorFn);

          reject(err);
        };

        _this3.addEventListener("suggest", _suggestFn);

        _this3.addEventListener("suggesterror", _suggestErrorFn);
      });
    }
  }, {
    key: "clear",
    value: function clear() {
      this.suggest("");
    }
  }, {
    key: "retrieve",
    value: function retrieve(suggestion, options) {
      return __async(this, null,
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee12() {
        var res;
        return _regeneratorRuntime.wrap(function _callee12$(_context12) {
          while (1) {
            switch (_context12.prev = _context12.next) {
              case 0:
                _context12.next = 2;
                return this.search.retrieve(suggestion, __spreadValues({
                  sessionToken: this.sessionToken
                }, options));

              case 2:
                res = _context12.sent;
                this.fire("retrieve", res);
                return _context12.abrupt("return", res);

              case 5:
              case "end":
                return _context12.stop();
            }
          }
        }, _callee12, this);
      }));
    }
  }, {
    key: "canRetrieve",
    value: function canRetrieve(suggestion) {
      if (!this.search.canRetrieve) {
        return true;
      }

      return this.search.canRetrieve(suggestion);
    }
  }, {
    key: "canSuggest",
    value: function canSuggest(suggestion) {
      if (!this.search.canSuggest) {
        return true;
      }

      return this.search.canSuggest(suggestion);
    }
  }, {
    key: "abort",
    value: function abort() {
      __privateGet(this, _abort).abort();

      __privateSet(this, _abort, createAbortController());
    }
  }, {
    key: "suggestions",
    get: function get() {
      return __privateGet(this, _suggestions);
    }
  }]);

  return SearchSession;
}(Evented);

_suggestions = new WeakMap();
_abort = new WeakMap();
_suggestDebounce = new WeakMap(); // src/featureToSuggestion.ts

function featureToSuggestion(feature) {
  var properties = feature.properties;
  return __spreadValues({}, properties);
}

export { Evented, LngLat, LngLatBounds, MapboxAutofill, MapboxError, MapboxGeocode, MapboxSearch, MapboxValidate, MatchCodeConfidence, SearchSession, SessionToken, debounce, featureToSuggestion, polyfillFetch };